$(function () {
    if ($('.footer').length > 0) {

        if ($('.down-bg-qrcode-app-img').length>0) {
            var qrcode = new QRCode(document.getElementsByClassName('down-bg-qrcode-app-img')[0], {
                width: 65,
                height: 65
            });
            var url = $('.down-bg-qrcode-app-img').data('url');
            qrcode.makeCode(url);
        }

        $('.footer-down-btn').hover(function () {
            var left = $(this).position().left;
            var top = $(this).position().top;
            var type = $(this).data('type');
            $('.down-bg-qrcode').hide();
            $('.down-bg-qrcode-' + type).show();
            $('.down-bg').css('left', left - 25);
            $('.down-bg').css('top', top - 15);
            $('.down-bg').show();
        }, function () {
            $('.down-bg').hide();
        });
    }
});